"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DateDisplay: function() {
        return _DateDisplay.DateDisplay;
    },
    RelativeDate: function() {
        return _RelativeDate.RelativeDate;
    },
    TimeDisplay: function() {
        return _TimeDisplay.TimeDisplay;
    },
    TimeRange: function() {
        return _TimeRange.TimeRange;
    },
    toDateString: function() {
        return _DateDisplay.toDateString;
    },
    toRelativeDateString: function() {
        return _RelativeDate.toRelativeDateString;
    },
    toTimeRangeString: function() {
        return _TimeRange.toTimeRangeString;
    },
    toTimeString: function() {
        return _TimeDisplay.toTimeString;
    }
});
const _DateDisplay = require("./DateDisplay");
const _RelativeDate = require("./RelativeDate");
const _TimeDisplay = require("./TimeDisplay");
const _TimeRange = require("./TimeRange");

//# sourceMappingURL=index.js.map